<template>
  <div class="filter-status btnHover">
    <el-dropdown trigger="click" @command="handleCommand">
      <span class="el-dropdown-link">
        <i class="icon iconfont iconicon_task_list"></i>{{title}}
      </span>
      <el-dropdown-menu slot="dropdown" class="filter-status-dropdown" >
        <el-dropdown-item
        v-for="(item) in dataset"
        :key="item.value"
        :command="item.value"
        >
        <toolTip :title="item.label"><span>{{item.label}}</span></toolTip>
          <i class="icon iconfont iconicon_selected_more_task" v-show="currentVal === item.value"></i>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: 'update_time_sort'
    }
  },
  data() {
    return {
      dataset: [{
        label: '修改时间',
        value: 'update_time_sort'
      },{
        label: '文件名',
        value: 'name_sort'
      }]
    }
  },
  computed: {
    currentVal:{
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    },
    title() {
      return (this.dataset.find(res => res.value === this.currentVal)).label
    }
  },
  methods: {
    handleCommand(val) {
      if(this.currentVal === val) return
      this.currentVal = val
      this.$emit('change', val)
    }
  }
}
</script>
<style lang="scss">
.filter-status {
}
</style>
